import iceModImg from "../../../../images/contents/map/sigwx/ice_mod.png";
import iceSevImg from "../../../../images/contents/map/sigwx/ice_sev.png";
import noneImg from "../../../../images/contents/map/sigwx/none.png";
import tropicStormSevNImg from "../../../../images/contents/map/sigwx/tropic_storm_sev_n.png";
import tropicStormSevSImg from "../../../../images/contents/map/sigwx/tropic_storm_sev_s.png";
import turbModImg from "../../../../images/contents/map/sigwx/turb_mod.png";
import turbSevImg from "../../../../images/contents/map/sigwx/turb_sev.png";

export const configSigwxDhUsHigh = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_USWAFC_SIGWX/High/index.json",
    "retain": true,
    "update_interval": 60,
    "cache": false,
    "cache_busting": true
  },
  "data": {
    "Type": "GeoJSON",
    "name": "USWAFC_High",
    "url": "%wrap_url%/WX_USWAFC_SIGWX/High/%basetime%/%validtime%.json",
    "cache": true,
    "retain": true
  }
};

export const configSigwxDhUsMiddle = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_USWAFC_SIGWX/Middle/index.json",
    "retain": true,
    "update_interval": 60,
    "cache": false,
    "cache_busting": true
  },
  "data": {
    "Type": "GeoJSON",
    "name": "USWAFC_MIDDLE",
    "url": "%wrap_url%/WX_USWAFC_SIGWX/Middle/%basetime%/%validtime%.json",
    "cache": true,
    "retain": true
  }
};

export const configSigwxDhUkHigh = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_UKWAFC_SIGWX/High/index.json",
    "retain": true,
    "update_interval": 60,
    "cache": false,
    "cache_busting": true
  },
  "data": {
    "Type": "GeoJSON",
    "name": "UKWAFC_High",
    "url": "%wrap_url%/WX_UKWAFC_SIGWX/High/%basetime%/%validtime%.json",
    "cache": true,
    "retain": true
  }
};

export const configSigwxDhUkMiddle = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_UKWAFC_SIGWX/Middle/index.json",
    "retain": true,
    "update_interval": 60,
    "cache": false,
    "cache_busting": true
  },
  "data": {
    "Type": "GeoJSON",
    "name": "UKWAFC_MIDDLE",
    "url": "%wrap_url%/WX_UKWAFC_SIGWX/Middle/%basetime%/%validtime%.json",
    "cache": true,
    "retain": true
  }
};

export const configSigwxLayer = {
  "Name": "SIGWX",
  "Renderer": "SIGWX",
  "Attributes": {
    "cloud_line_color": "#00B100",
    "cloud_line_width": 2,
    "cloud_line_orientation": "clockwise",
    "cloud_label_color": "rgb(159, 57, 185)",
    "cloud_ice_mod_icon": iceModImg,
    "cloud_ice_sev_icon": iceSevImg,
    "cloud_turb_mod_icon": turbModImg,
    "cloud_turb_sev_icon": turbSevImg,
    "cloud_icon_width": 20,
    "cloud_icon_height": 20,
    "turbulence_color_mod": "#F28CBB",
    "turbulence_color_mod_to_sev": "#FF5E19",
    "turbulence_color_sev": "#CC000A",
    "turbulence_line_width": 2,
    "turbulence_label_color": "rgb(159, 57, 185)",
    "volcano_icon": noneImg,//非表示
    "volcano_icon_width": 1,
    "volcano_icon_height": 1,
    "volcano_label_color": "rgb(159, 57, 185, 0)",
    "tropic_storm_n_icon": tropicStormSevNImg,
    "tropic_storm_s_icon": tropicStormSevSImg,
    "tropic_storm_icon_width": 16,
    "tropic_storm_icon_height": 32,
    "sand_storm_icon": noneImg,
    "sand_storm_icon_width": 1,
    "sand_storm_icon_height": 1,
    "radioactivity_icon": noneImg,
    "radioactivity_icon_width": 1,
    "radioactivity_icon_height": 1,
    "jetstream_line_color": "#0059ff",
    "jetstream_line_width": 2,
    "jetstream_label_color": "#0067C5",
    "end": null
  }
};